import React, { useCallback, useMemo } from 'react'
import Select, { SingleValue } from 'react-select'

import { createTimeOptions, TimeOption } from './utils'

const OPTIONS = createTimeOptions()

type Props = {
  value?: number
  onChange?: (minutes: number) => void
}

function TimeSelect({ value, onChange }: Props) {
  const currentValue = useMemo(
    () => OPTIONS.find(option => option.value === value),
    [value],
  )

  const handleChange = useCallback(
    (option: SingleValue<TimeOption>) => {
      if (!option) return
      onChange?.(option.value)
    },
    [onChange],
  )

  return (
    <Select
      menuPlacement="top"
      options={OPTIONS}
      value={currentValue}
      onChange={handleChange}
    />
  )
}

export default TimeSelect
